import { render, staticRenderFns } from "./table-head.vue?vue&type=template&id=0b65f8ea&scoped=true"
import script from "./table-head.vue?vue&type=script&lang=js"
export * from "./table-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b65f8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b65f8ea')) {
      api.createRecord('0b65f8ea', component.options)
    } else {
      api.reload('0b65f8ea', component.options)
    }
    module.hot.accept("./table-head.vue?vue&type=template&id=0b65f8ea&scoped=true", function () {
      api.rerender('0b65f8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/table/table-head.vue"
export default component.exports